import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Components
import Announcement from "../../components/Announcement/Announcement"
import Navbar from "../../components/Navbar/Navbar"
import EventBar from "../../components/EventBar/EventBar"
import Logo from "../../components/Logo/Logo"
import HeroImage from "../../components/HeroImage/HeroImage"
import Categories from "../../components/Categories/Categories"
import PageImages from "../../components/PageImages/PageImages"
import Newsletter from "../../components/Newsletter/Newsletter"
import Footer from "../../components/Footer/Footer"
// Styles
import { Container } from "./Home.styles"

const Home = () => {
   const { t } = useTranslation()
   const [bgImageColor, setBgImageColor] = useState("dark")

   useEffect(() => {
      const screenHeight = window.innerHeight
      const handleScroll = () => {
         if (window.scrollY > screenHeight) {
            setBgImageColor("dark")
         } else {
            setBgImageColor("dark")
         }
      }

      window.addEventListener("scroll", handleScroll)
      return () => window.removeEventListener("scroll", handleScroll)
   }, [])

   return (
      <>
         <Helmet>
            <title>{t("homePage.meta.meta_title")}</title>
            <meta
               name="description"
               content={t("homePage.meta.meta_description")}
            />
         </Helmet>
         <Container>
            <Navbar bgImageColor={bgImageColor} />

            <EventBar />

            <Announcement />
            <Logo bgImageColor={bgImageColor} />
            <HeroImage imageHeight={"100svh"} imageNumber={0} />
            <Categories />
            <PageImages />
            <Newsletter />
            <Footer />
         </Container>
      </>
   )
}

export default Home
